import * as Sentry from "@sentry/angular";

import { HttpErrorResponse } from "@angular/common/http";

export function reportAndReturn<T>(val: T) {
  // FIXME: This is a hack to suppress fetching errors without crashing
  // the app and still report issues. There is probably a better fundamental
  // solution.
  const func = (err: unknown) => {
    // Status 0 means the request never reached the server (offline, aborted,
    // connection dropped). That is a client-side condition we cannot act on.
    if (!(err instanceof HttpErrorResponse && err.status === 0)) {
      Sentry.captureException(err);
    }
    return val;
  };
  return func;
}
